import React from "react";
import {
  Box,
  Flex,
  Img,
  Link,
  Text,
  useBreakpointValue,
} from "@chakra-ui/react";
import SVG from "react-inlinesvg";
import FeatureSectionContainer from "@/features/landing/components/common/FeatureSectionContainer";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import { Trans } from "react-i18next";

interface Props {
  isSignedIn: boolean;
}

export function LandingPageOrderSection({ isSignedIn }: Props): JSX.Element {
  const { tTitle, i18n } = useI18nHelper();
  const isKor = i18n.language === "ko";

  return (
    <Flex
      as={"section"}
      aria-labelledby={"landing-order-title"}
      paddingX={{
        base: "16px",
        lg: "24px",
      }}
    >
      <FeatureSectionContainer maxWidth={"1318px"} margin={"0 auto"}>
        <Flex
          flexDirection={"column"}
          gap={{
            base: "12px",
            lg: "24px",
          }}
          alignItems={{
            base: "center",
            md: "flex-start",
          }}
          flex={1}
        >
          <Text
            color={"#1272EF"}
            fontSize={{
              base: "16px",
              lg: "24px",
            }}
            fontWeight={700}
            lineHeight={{
              base: "24px",
              lg: "32px",
            }}
            as={"h2"}
            id={"landing-order-title"}
          >
            {tTitle("landing:order.title")}
          </Text>
          <Text
            flexDirection={"column"}
            fontSize={{
              base: "28px",
              lg: "48px",
            }}
            fontWeight={700}
            textAlign={{
              base: "center",
              md: "start",
            }}
            lineHeight={{
              base: "38px",
              lg: "68px",
            }}
          >
            <Trans
              i18nKey={"landing:order.subtitle"}
              components={{
                br: (
                  <Box
                    as={"span"}
                    display={{
                      base: "block",
                      md: "none",
                    }}
                  />
                ),
              }}
            />
          </Text>
          <Text
            fontSize={{
              base: "16px",
              lg: "24px",
            }}
            lineHeight={{
              base: "24px",
              lg: "32px",
            }}
            color={"#737373"}
            textAlign={{
              base: "center",
              md: "start",
            }}
          >
            <Trans
              i18nKey={"landing:order.description"}
              components={{
                br: (
                  <Box
                    as={"span"}
                    display={{
                      base: "none",
                      md: "block",
                    }}
                  />
                ),
              }}
            />
          </Text>
        </Flex>
        <Flex
          justifyContent={"center"}
          alignItems={"center"}
          background={"#F8F8F8"}
          borderRadius={"16px"}
          flex={1}
        >
          <Img
            src={`/images/landing-order-line-sheet${isKor ? "" : "-eng"}.webp`}
            alt={"screen example of line sheet"}
          />
        </Flex>
      </FeatureSectionContainer>
    </Flex>
  );
}
